<app-subheader-main></app-subheader-main>

<div class="dashboard height-adjust-95">
    <div class="cover-img-container">
        
        <div class="cover-img-text-overlay">
            <div></div>
            <div class="cover-img-text-container">
                <div class="welcome-message">{{ getWelcomeMessage() }}</div>
                <div class="membership-validate-time">{{ getMembershipValidateTime() }}</div>
            </div>
            <!-- <div class="cover-action-container">{{'dashboard.lbl_photo_by' | translate}}</div>   -->
        </div>        
    </div>
    <div class="editor-container">
        <div class="panels-container">
            <div class="border-outline panles-border">
                <div class="panels">
                    <!-- Left Pannel -->
                    <div class="left-panel">

                        <!-- Video Tab -->
                        <div class="video-tab">
                            <iframe class="border-outline video" [src]="youtubeUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>

                        <!-- family summary -->
                        <div class="border-outline family-summary-tab">
                            <h1 class="label-l-grey-bold">{{'dashboard.lbl_my_family_tree' | translate}}</h1>
                            <div class="table-box">
                                <table class="table-data">
                                    <th colspan="2">{{ getCurrentProjectName() }}</th>
                                    <tr *ngFor="let item of familySummaryTableData">
                                        <td class="table-key">{{ item.translationKey | translate }}</td>
                                        <td class="table-value">{{ familyProjectDetails[item.property] }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        
                    </div>

                    <div class="center-panel">

                        <!-- Expire Message -->
                        <app-expire-message (expireStateChange)="onExpireStateChange($event)"></app-expire-message>

                        <!-- Tree Navigator Tab -->
                        <div [ngSwitch]="getMessageState()">
                            <!-- 0 - New user -->
                            <div *ngSwitchCase="0" class="border-outline tree-navigator-tab" [ngClass]="isExpireMessageVisible ? 'min-height-tab' : 'max-height-tab'">              
                                <div>
                                    <span class="label-xl-grey">{{'dashboard.lbl_create_or_import' | translate}}</span>                    
                                </div>
                                <div class="import-create-buttons">
                                    <button class="ft-btn ft-btn-active" (click)="openCreateImportPanel(1)"> {{'dashboard.lbl_create_new' | translate}} </button>
                                    <button class="ft-btn ft-btn-active" (click)="openCreateImportPanel(2)"> {{'dashboard.lbl_import' | translate}} </button>
                                </div>
                            </div>
                            <!-- 1 - Continue with existing -->
                            <div *ngSwitchCase="1" class="border-outline tree-navigator-tab" [ngClass]="isExpireMessageVisible ? 'min-height-tab' : 'max-height-tab'">                              
                                <span class="label-xl-grey"> {{'dashboard.lbl_continue_work' | translate}} <br> {{ getCurrentProjectName() }} &nbsp; </span>
                                <button class="ft-btn ft-btn-active" (click)="openTreeEditor()"> {{'dashboard.lbl_continue' | translate}} </button>
                            </div>
                            <!-- 2 - Still Importing -->
                            <div *ngSwitchCase="2" class="border-outline tree-navigator-tab" [ngClass]="isExpireMessageVisible ? 'min-height-tab' : 'max-height-tab'">              
                                <div>
                                    <p class="label-l-grey">{{'dashboard.lbl_import_error' | translate}}</p>
                                </div>
                                <div>
                                    <button class="ft-btn ft-btn-active" (click)="openTab(getEnvironment().FT_HELP_URL+getFtHelpRoute(''))">{{'dashboard.lbl_support_case' | translate}}</button>
                                </div>
                            </div>
                            <!-- 3 - Invalid -->
                            <div *ngSwitchCase="3" class="border-outline tree-navigator-tab" [ngClass]="isExpireMessageVisible ? 'min-height-tab' : 'max-height-tab'">              
                                <div>
                                    <span class="label-l-grey">{{'dashboard.lbl_tree_loading_error' | translate}}</span>
                                </div>
                                <div>
                                    <button class="ft-btn ft-btn-active" (click)="openTab(getEnvironment().FT_HELP_URL+getFtHelpRoute(''))">{{'dashboard.lbl_support_case' | translate}}</button>
                                </div>
                            </div>
                        </div>
                            
                        <!-- Celebrations of the month - Start -->
                        <div class="border-outline celebrations-tab">
                            <h1 class="label-l-grey-bold">{{'dashboard.lbl_celebrations.title' | translate}} {{getToday('MMMM')}}</h1>
                            <div *ngIf="celebrations?.length > 0; else default_cards" class="overflow-auto release-notes-box celebrations-box" >
                                <div *ngFor="let celebration of celebrations" class="cards-container">
                                    <!-- Birthday  -->
                                    <div *ngIf="celebration.type == 'BirthdayGreeting'" class="celebrations-card d-flex px-3 py-2 border-outline">
                                        <div class="celebrations-card__icon-wrapper pr-3 d-flex align-items-center">
                                            <i class="celebrations-card__icon fa fa-birthday-cake"></i>
                                        </div>
                                        <div class="celebrations-card__content">
                                            <div class="celebrations-card__details">
                                                <div class="celebrations-card__message label-l-grey mb-1">{{'dashboard.lbl_celebrations.its' | translate}} <strong>{{celebration.individual.givenName}}</strong> {{'dashboard.lbl_celebrations.birthday' | translate}} {{celebration.date}}</div>
                                                <div class="celebrations-card__action-btn px-3 py-1 d-inline-block rounded" (click)="openGreetingReport(celebration.type, celebration.individual)">
                                                    <span>{{'dashboard.lbl_celebrations.greet' | translate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <!-- Anniversary  -->
                                    <div *ngIf="celebration.type == 'AnniversaryGreeting'" class="celebrations-card d-flex px-3 py-2 border-outline">
                                        <div class="celebrations-card__icon-wrapper pr-3 d-flex align-items-center">
                                            <img src="../assets/images/dashboard/anniversary.svg" class="celebrations-card__icon">
                                        </div>
                                        <div class="celebrations-card__content">
                                            <div class="celebrations-card__details">
                                                <div class="celebrations-card__message label-l-grey mb-1">{{'dashboard.lbl_celebrations.its' | translate}} <strong>{{celebration.individual.givenName}} & {{celebration.individual.spouseName}}</strong> {{'dashboard.lbl_celebrations.anniversary' | translate}} {{celebration.date}}</div>
                                                <div class="celebrations-card__action-btn px-3 py-1 d-inline-block rounded" (click)="openGreetingReport(celebration.type, celebration.individual)">
                                                    <span>{{'dashboard.lbl_celebrations.greet' | translate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #default_cards>
                                <div class="celebrations-box">
                                    <!-- Birthday  -->
                                    <div class="celebrations-card d-flex px-3 py-2 border-outline cards-container">
                                        <div class="celebrations-card__icon-wrapper pr-3 d-flex align-items-center">
                                            <i class="celebrations-card__icon fa fa-birthday-cake"></i>
                                        </div>
                                        <div *ngIf="true" class="celebrations-card__default">
                                            <div class="celebrations-card__message label-l-grey mb-1">{{'dashboard.lbl_celebrations.default_birthday' | translate}}</div>
                                            <div class="celebrations-card__action-btn px-3 py-1 d-inline-block rounded">
                                                <span (click)="openTreeEditor()">{{'dashboard.lbl_celebrations.tree_editor' | translate}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Anniversary  -->
                                    <div class="celebrations-card d-flex px-3 py-2 border-outline cards-container">
                                        <div class="celebrations-card__icon-wrapper pr-3 d-flex align-items-center">
                                            <img src="../assets/images/dashboard/anniversary.svg" class="celebrations-card__icon">
                                        </div>
                                        <div class="celebrations-card__content">
                                            <div *ngIf="true" class="celebrations-card__default">
                                                <div class="celebrations-card__message label-l-grey mb-1">{{'dashboard.lbl_celebrations.default_anniversary' | translate}}</div>
                                                <div class="celebrations-card__action-btn px-3 py-1 d-inline-block rounded">
                                                    <span (click)="openTreeEditor()">{{'dashboard.lbl_celebrations.tree_editor' | translate}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <!-- Celebrations of the month - End -->
                    </div>
                    
                    <!-- Right Pannel -->
                    <div class="right-panel">
                        <!-- Upgrade -->      
                        <!-- <div class="upgrade-tab border-outline coming-soon-cover"> -->
                            <!-- <span class="label-xl-grey">{{'dashboard.lbl_upgrade_features' | translate}}</span> -->
                            <!-- Need to implement openupgradepannel -->
                            <!-- <button class="ft-btn ft-btn-active">{{'dashboard.lbl_upgrade_now' | translate}}</button> -->
                            <!-- <button class="ft-btn ft-btn-active">{{'dashboard.lbl_upgrade_now' | translate}}</button> -->
                        <!-- </div> -->
                        
                        <!-- Whats new -->
                        <div class="border-outline whats-new-tab">
                           <h1 class="label-l-grey-bold">{{'dashboard.lbl_whats_new.title' | translate}}</h1>
                           <div class="release-notes-box overflow-auto">
                               <div class="note-content" *ngFor="let note of whatsNewNotes">
                                   <p class="label-l-grey">{{ note.description | translate }}</p>
                                   <span class="label-s-grey">{{ note.date | translate }}</span>
                                   <span class="label-xs-grey">{{ note.version | translate }}</span>
                               </div>
                           </div>
                        </div>

                       
                    </div>
                </div>
                <div class="programs-backup" *ngIf="!hasPurchasedV10Only()">
                    <div class="row">
                        <!-- Your Programs -->
                        <div class="col-lg-6 mb-4">
                            <div class="border-outline">
                                <h1 class="label-l-grey-bold">{{'dashboard.lbl_your_programs.title' | translate}}</h1>
                                <section class="programs-card h-100 shadow-sm">
                                    <div class="programs-card__body card-body">
                                        <p class="programs-card__description mb-3">
                                            {{'dashboard.lbl_your_programs.description_01' | translate}}
                                        </p>
                                        <p class="programs-card__description mb-3">
                                            {{'dashboard.lbl_your_programs.description_02' | translate}}
                                        </p>
                        
                                        <div class="table-responsive border-outline">
                                            <table class="programs-card__table table table-sm table-hover mb-0" aria-label="Your programs list">
                                                <thead class="programs-card__table-head">
                                                    <tr>
                                                        <th scope="col" class="programs-card__col-name">
                                                            {{'dashboard.lbl_your_programs.table_title_01' | translate}}
                                                        </th>
                                                        <th scope="col" class="programs-card__col-version">
                                                            {{'dashboard.lbl_your_programs.table_title_02' | translate}}
                                                        </th>
                                                        <th scope="col" class="programs-card__col-license">
                                                            {{'dashboard.lbl_your_programs.table_title_03' | translate}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr class="programs-card__row" *ngFor="let program of programs">
                                                        <td class="programs-card__cell-name">
                                                            <button type="button" class="programs-card__download-btn btn btn-link p-0" 
                                                            (click)="onProgramDownload(program)">
                                                                {{ program.name | translate}}
                                                            </button>
                                                        </td>
                                                        <td class="programs-card__cell-version">{{ program.displayVersion }}</td>
                                                        <td class="programs-card__cell-license">{{ program.licenseKeys || '-'}}</td>
                                                    </tr>
                        
                                                    <tr *ngIf="!programs || programs.length === 0"
                                                        class="programs-card__row programs-card__row--empty">
                                                        <td colspan="3" class="text-center text-muted py-4">
                                                            {{'dashboard.lbl_your_programs.no_programs_available' | translate}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <!-- Backup -->
                        <div class="col-lg-6 mb-4">
                            <section class="backup card h-100">
                                <div class="backup__header">
                                    <h1 class="label-l-grey-bold">{{'dashboard.lbl_backup.backup' | translate}}</h1>
                                </div>
                        
                                <div class="backup__body card-body">
                                    <!-- Dropzone -->
                                    <div class="backup__dropzone" [class.backup__dropzone--active]="isDragOver"  [class.backup__dropzone--disabled]="isUploading" (dragover)="onDragOver($event)"
                                        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                                        <div class="backup__dropzone-inner text-center">
                                            <div class="backup__icon-wrapper mb-2">
                                                <img src="../../../../assets/images/icons/upload-icon.svg">
                                            </div>
                        
                                            <p class="backup__title mb-2">
                                                {{'dashboard.lbl_backup.drag_drop' | translate}}
                                            </p>
                        
                                            <!-- description texts ... -->
                                            <p class="backup__description">
                                                {{'dashboard.lbl_backup.description' | translate}}
                                            </p>
                                            <button class="btn ft-btn-primary" type="button" (click)="fileInput.click()">
                                                {{'dashboard.lbl_backup.browse_file' | translate}}
                                            </button>
                                            <input #fileInput type="file" class="backup__file-input d-none" (change)="onFileSelected($event)" />
                                        </div>
                                    </div>
                        
                                    <!-- Selected file + upload row -->
                                    <div class="backup__selected mt-4">
                                        <label class="backup__field-label d-block mb-1"  [ngClass]="{ 'text-warning': isUploading }">
                                            {{ (isUploading ? 'dashboard.lbl_backup.uploading' : 'dashboard.lbl_backup.selected_file') | translate }}
                                        </label>
                        
                                        <div class="backup__field-row d-flex align-items-center">
                                            <div class="backup__file-display form-control"
                                                [ngClass]="{'backup__file-display--error is-invalid': hasValidationError || hasUploadError}">
                                                <input type="text" class="backup__file-name-input" [placeholder]="'dashboard.lbl_backup.select_file_upload' | translate"
                                                    [(ngModel)]="selectedFileName" [readonly]="true" />
                                            
                                                <button *ngIf="selectedFileName" type="button" class="backup__file-clear"
                                                    (click)="onClearFile()" aria-label="Clear selected file">
                                                    <i class="fa fa-times-circle" [ngClass]="{'i-error': hasValidationError || hasUploadError}"></i>
                                                </button>
                                            </div>
                        
                                            <button type="button" class="backup__upload-btn btn ft-btn-primary ft-btn-primary--small ml-3"
                                                [disabled]="!selectedFile || hasValidationError || isUploading" (click)="onUpload()">
                                                {{'dashboard.lbl_backup.upload' | translate}}
                                            </button>
                                        </div>
                        
                                        <!-- progress -->
                                        <div class="backup__progress mt-2" *ngIf="isUploading">
                                            <div class="backup__progress-track">
                                                <div class="backup__progress-bar" [ngClass]="{ 'backup__progress-bar--error': hasUploadError }"
                                                    [style.width.%]="uploadProgress"></div>
                                            </div>
                                            <small class="backup__progress-value ml-2"
                                                [ngClass]="{ 'backup__progress-value--error': hasUploadError }">
                                                {{ uploadProgress }}%
                                            </small>
                                        </div>
                        
                                        <!-- validation / upload error message -->
                                        <p class="backup__error-text mt-1" *ngIf="hasValidationError">
                                            {{'dashboard.lbl_backup.error.invalid_file' | translate}}
                                        </p>
                                        <p class="backup__error-text" *ngIf="hasUploadError">
                                            {{'dashboard.lbl_backup.error.unknown_error' | translate}}
                                        </p>
                                    </div>

                                    <!-- Data Table  -->
                                    <div class="backup__data mt-4">
                                        <!-- Table -->
                                        <table class="backup__table table mb-0" *ngIf="backupFiles.length; else noDataTpl">
                                            <thead>
                                                <tr>
                                                    <th class="backup__cell--checkbox">
                                                        <input #headerCheckbox class="table__checkbox" type="checkbox" (change)="onToggleAll($event)" [checked]="allSelected" />
                                                    </th>
                                                    <th>{{'dashboard.lbl_backup.name' | translate}}</th>
                                                    <th>{{'dashboard.lbl_backup.size' | translate}}</th>
                                                    <th>{{'dashboard.lbl_backup.date' | translate}}</th>
                                                    <th class="text-center">{{'dashboard.lbl_backup.action' | translate}}</th>
                                                </tr>
                                            </thead>
                                    
                                            <tbody>
                                                <tr *ngFor="let file of backupFiles">
                                                    <td class="backup__cell--checkbox">
                                                        <input class="table__checkbox" type="checkbox" [checked]="file.selected" (change)="onToggleRow(file, $event)" />
                                                    </td>
                                    
                                                    <td class="backup__name-cell">
                                                        <a class="backup__file-link" [title]="file.backupName" (click)="onBackupDownload(file)">
                                                            {{ file.backupName }}
                                                        </a>
                                                    </td>
                                    
                                                    <td class="label-m">{{ file.backupSize }} MB</td>
                                                    <td class="label-m">{{ file.backupDate }}</td>
                                    
                                                    <td class="text-center">
                                                        <button type="button" class="backup__delete-btn" [disabled]="!file.selected"
                                                            (click)="onDelete(file)" aria-label="Delete file">
                                                            <i class="fa fa-trash-o fa-lg"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    
                                        <!-- No Data -->
                                        <ng-template #noDataTpl>
                                            <div class="backup__empty text-center">
                                                <div class="backup__empty-illustration mb-1">
                                                    <img src="../../../../assets/images/icons/no-data.svg" alt="No data" class="backup__empty-img" />
                                                </div>
                                                <div class="backup__empty-text label-l-grey">{{'dashboard.lbl_backup.no_files' | translate}}</div>
                                            </div>
                                        </ng-template>
                                                                              
                                    </div>
                                    <p class="backup__error-text mt-1" *ngIf="hasDeleteError">
                                        {{'dashboard.lbl_backup.error.delete_error' | translate}}
                                    </p>
                                    <!-- Delete All Selected button -->
                                        <div class="d-flex justify-content-end mt-3" *ngIf="selectedCount > 1">
                                            <button type="button" class="btn ft-btn-primary ft-btn-primary__danger ft-btn-primary--small" (click)="onDeleteSelected()">
                                                <i class="fa fa-trash-o mr-1 fa-lg"></i>
                                                {{'dashboard.lbl_backup.delete_all' | translate}} ({{ selectedCount }})
                                            </button>
                                        </div>  
                                </div>
                            </section>
                        </div>
                    </div>
                </div>


            </div>

            <!-- footer -->
            <footer>
                <section class="container-fluid footer-first pt-5">
                    <div class="container pb-2">
                        <div class="row">
                            <div class="col-md-6 col-lg-4 mb-2 mb-lg-0 col-first">
                                <h5 class="mb-3 fw-bold">{{'footer.first.company.lbl_title' | translate}}</h5>
                                <p class="app-description h6" *ngFor="let line of ('footer.first.company.lbl_subtitle' | translate)">
                                    {{ line }}
                                </p>
                            </div>
                            <div class="col-md-6 col-lg-2 mb-2 mb-lg-0 col-second">
                                <h5 class="mb-3 fw-bold">
                                    <a [href]="knowledgebaseUrl" target="_blank" class="text-decoration-none text-reset">
                                        {{ 'footer.first.support.lbl_title' | translate }}
                                    </a>
                                </h5>
                            </div>
                            <div class="col-md-6 col-lg-3 mb-4 mb-lg-0 col-third">
                                <h5 class="mb-3 fw-bold">{{'footer.first.connect_with_us.lbl_title' | translate}}</h5>
                                <div class="d-flex gap-2 pt-1">
                                    <a href="{{dashboard.FACEBOOK_PAGE_URL}}" target="_blank">
                                        <i class="fa-brands fa-facebook"></i>
                                    </a>
                                    <!-- <a href="{{socialMedia.INSTAGRAM_URL}}" target="_blank"><img src="/assets/images/icons/insta.png" alt="Instagram" /></a> -->
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3 mb-2 mb-lg-0 col-fourth app-description">
                                <p class="mb-2"><span>{{'footer.first.contact_info.lbl_address.lbl_address_line_1' |
                                        translate}}</span><br><span>{{'footer.first.contact_info.lbl_address.lbl_address_line_2' |
                                        translate}}</span><br><span>{{'footer.first.contact_info.lbl_address.lbl_address_line_3' |
                                        translate}}</span></p>
                                <a class="text-decoration-none"
                                    href="mailto: firmapost@embla.no">{{'footer.first.contact_info.lbl_email' | translate}}</a>
                                <p class="mb-2">{{'footer.first.contact_info.lbl_org_number' | translate}} : <span>988 610
                                        976</span></p>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="container-fluid footer-copyright d-flex">
                    <div class="container">
                        <div class="row">
                            <div class="col text-center">
                                <small class="footer__copy">
                                    &copy; 1996&nbsp;–&nbsp;{{ currentYear }} {{'footer.copyright.lbl_title' |
                                    translate}}&nbsp;&nbsp;|&nbsp;
                                    <a href="#" (click)="onPrivacyPolicyClick($event)" class="text-white text-decoration-none">
                                        {{ 'footer.copyright.lbl_privacy_statement' | translate }}
                                    </a>
                                </small>
                            </div>
                        </div>
                    </div>
                </section>
            </footer>


        </div>
    </div>
</div>